import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {number} */
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  #handleCartAdd = () => {
    // if (this.hasAttribute('auto-open')) {
    //   this.showDialog();
    // }

    if (false) {
      this.showDialog();
    }
  };

  open() {
    // this.showDialog();

    // /**
    //  * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
    //  */
    // customElements.whenDefined('shopify-payment-terms').then(() => {
    //   const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
    //   const cta = installmentsContent?.querySelector('#shopify-installments-cta');
    //   cta?.addEventListener('click', this.closeDialog, { once: true });
    // });

    window?.Rebuy?.SmartCart?.show();
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = /** @type {Refs} */ (this.refs);
    if (!dialog) return;

    // Refs do not cross nested `*-component` boundaries (e.g., `cart-items-component`), so we query within the dialog.
    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      // Ensure the dialog doesn't get stuck in "unsticky" mode when summary disappears (e.g., empty cart).
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;
    const ratio = summaryHeight / drawerHeight;
    dialog.setAttribute('cart-summary-sticky', ratio > this.#summaryThreshold ? 'false' : 'true');
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener("click", (e) => {
  const target = e.target;

  const clickedSelect = target.closest("[js-rebuy-subscription-frequency-select]");
  const allDropdowns = document.querySelectorAll("[js-rebuy-subscription-frequency]");

  if (clickedSelect) {
    const dropdown = clickedSelect.closest("[js-rebuy-subscription-frequency]");
    if (!dropdown) return;

    const isOpen = dropdown.classList.contains("is-open");

    allDropdowns.forEach(d => d.classList.remove("is-open"));

    if (!isOpen) {
      dropdown.classList.add("is-open");
    }

  } else {
    allDropdowns.forEach(d => d.classList.remove("is-open"));
  }
});